import { SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useResolutionsApi } from "../../../../../common/api/orders-api/resolution/useResolutionsApi";
import { DataHooksQueryKey } from "../../../../../common/data/data-hooks/DataHooksQueryKey";
import { Resolution } from "../../../../common/types/Resolution";

export const useResolutions = (): SprintQueryResult<Resolution[]> => {
    const { getResolutionList } = useResolutionsApi();

    return useSprintQuery<Resolution[]>({
        queryKey: [DataHooksQueryKey.Resolutions],
        queryFn: async (): Promise<Resolution[]> => {
            const response = await getResolutionList();
            return response.items;
        }
    });
};
